// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VertContainer {
    width: 100%;
    box-sizing: border-box;
    padding: 0 16px;
    margin: 0 auto;
}
`, "",{"version":3,"sources":["webpack://./src/Shared/common/components/Container/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,cAAc;AAClB","sourcesContent":[".VertContainer {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 0 16px;\n    margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
